module.exports = __webpack_public_path__ + "static/media/heart-medical.eeb4bafe.svg";